import type { AccountFetchedAction } from '@Application/Accounts/Actions/accountFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import AccountView from '@UI/Store/Account/Views/AccountView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AccountStore = {
	account: AccountView | null;
};

const initialState: AccountStore = {
	account: null,
};

type Actions = AccountFetchedAction | UserRevokedAction;

const whenAccountFetched = (store: AccountStore, action: AccountFetchedAction): AccountStore => ({
	...store,
	account: new AccountView(action.payload),
});

const whenUserRevoked = (): AccountStore => initialState;

export default registerStore<'accountStore', Actions>(
	'accountStore',
	createSliceReducer({
		ACCOUNT_FETCHED: whenAccountFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
